var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeHidden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.477 3.513c-.263-.263-.714-.24-1.007.053-.293.293-.317.744-.053 1.008l12.545 12.545c.264.264.715.24 1.008-.053.293-.293.316-.744.053-1.007l-1.78-1.78C16.932 12.685 18 10.764 18 10.036c0-1.334-3.582-6.667-8-6.667-1.52 0-2.942.632-4.152 1.514l-1.37-1.37zm3.239 3.239l5.568 5.568a4 4 0 00-5.568-5.568z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.703c1.014 0 1.984-.281 2.876-.73l-2.027-2.027A4 4 0 016.09 9.187L3.756 6.853C2.657 8.16 2 9.465 2 10.036c0 1.333 3.582 6.667 8 6.667z"
  })));
}

export default SvgEyeHidden;